import(/* webpackMode: "eager", webpackExports: ["PartnerFormDialog"] */ "/app/components/admin/partners/partner-form-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/admin/partners/partners-page-client.tsx");
